import { createFileRoute } from "@tanstack/react-router";
import { normalizeLoginSearch } from "~/features/login/login-route";
import { m } from "~/lib/i18n";

export const Route = createFileRoute("/login")({
  head: () => ({
    meta: [
      { title: m.login_page_meta_title() },
      { content: m.login_page_meta_description(), name: "description" },
    ],
  }),
  validateSearch: normalizeLoginSearch,
});
